@if (link.visibilityCondition !== false) {
  <div class="nav-el" [routerLinkActive]="'active'" (isActiveChange)="onMainLinkDeactivated($event)">
    <a
      class="main-link"
      [class.expanded]="expanded$ | async"
      [routerLink]="link.subLinks?.length ? null : link.routerLink"
      [queryParams]="link.subLinks?.length ? null : link.queryParams"
      (click)="togglePanel()"
    >
      <div class="link">
        <div class="name">
          @if (link.icon) {
            <mat-icon class="icon" [svgIcon]="link.icon"></mat-icon>
          }

          <div class="text">{{ link.label | translate }}</div>
        </div>
        @if (link.subLinks?.length) {
          <mat-icon class="expand-button">expand_more</mat-icon>
        }
      </div>
    </a>

    @if (link.subLinks?.length) {
      <div
        class="expandable"
        [class.expanded]="expanded$ | async"
        [style.max-height]="link.subLinks!.length * 34 + 'px'"
      >
        @for (subLink of link.subLinks; track subLink) {
          @if (subLink.visibilityCondition !== false) {
            <a
              #subLinkElem
              class="sub-link"
              [routerLinkActive]="'active'"
              [routerLink]="subLink.routerLink"
              [queryParams]="subLink.queryParams"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              {{ subLink.label | translate }}
            </a>
          }
        }
      </div>
    }
  </div>
}
